import ErrorToast from "../../components/toast/ErrorToast";
import {
  FILE_PAGE_OVERFLOW,
  INFERENCE_FAIL,
} from "../../constants/ErrorMessage";
import { INFERENCE_STATE } from "../../hooks/useFile";
import { FileUploadCallbacks } from "../../types/upload";
import { validateInputFile } from "../../utils/file";

export const handleInputValidation = (
  inputFiles: File[],
  errorType: number,
  skipValidation: boolean,
  callbacks: FileUploadCallbacks,
): boolean => {
  if (skipValidation) return true;

  const {
    setErrorType = () => {},
    setErrorOn = () => {},
    setErrorCloseFunction = () => {},
    setErrorReloadFunction = () => {},
  } = callbacks;

  if (!validateInputFile(inputFiles[0], setErrorType)) {
    setErrorOn(true);
    setupErrorCallbacks(
      errorType,
      setErrorOn,
      setErrorCloseFunction,
      setErrorReloadFunction,
    );
    return false;
  }

  return true;
};

const setupErrorCallbacks = (
  errorType: number,
  setErrorOn: (on: boolean) => void,
  setErrorCloseFunction: (func: () => void) => void,
  setErrorReloadFunction: (func: () => void) => void,
) => {
  setErrorCloseFunction(() => () => {
    document.getElementById("file-upload")?.click();
    setErrorOn(false);
  });

  if (errorType === FILE_PAGE_OVERFLOW) {
    setErrorReloadFunction(() => () => {
      setErrorOn(false);
      console.warn("File page overflow, manual retry might be needed.");
    });
  } else {
    setErrorReloadFunction(() => () => {
      setErrorOn(false);
    });
  }
};

export const handleUploadError = (
  error: any,
  callbacks: FileUploadCallbacks,
) => {
  console.error("File upload failed:", error);

  ErrorToast({
    title: "File upload error. Please refresh.",
    description: error?.message,
  });

  const {
    setInferenceState,
    setErrorOn = () => {},
    setErrorType = () => {},
    setErrorCloseFunction = () => {},
    setErrorReloadFunction = () => {},
  } = callbacks;

  setErrorOn(true);
  setInferenceState(INFERENCE_STATE.IDLE);
  setErrorType(INFERENCE_FAIL);

  setErrorCloseFunction(() => () => setErrorOn(false));
  setErrorReloadFunction(() => () => {
    setErrorOn(false);
    console.warn("Upload failed, manual retry might be needed.");
  });
};
